import React from 'react';
import { Doughnut } from 'react-chartjs-2';
const DonutChartContainer = ({ color, data }) => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            // Access the dataset label and data for the segment
            const label = context.chart.data.labels[context.dataIndex];
            const value = context.raw;

            // If the label is not found, ensure we handle it gracefully
            return label ? `${label}: ${value}` : `Value: ${value}`;
          },
        },
      },
    },
  };
  const dataD = {
    maintainAspectRatio: false,
    responsive: false,
    labels: data.map(item => item.lable),
    datasets: [
      {
        data: data.map(item => item.value),
        backgroundColor: color.slice(0, data.length),
        borderColor: color.slice(0, data.length),
        borderWidth: 1
      }
    ]
  };
  return (
    <>
      <div className="max-w-[180px] sm:max-w-[247px]">
        <Doughnut data={dataD} options={options} />
      </div>
    </>
  );
};
export default DonutChartContainer;